import { action, runInAction } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'

import ExternalPromocodeModel from './ExternalPromocodeModel'

export type $ExternalPromocodeStore = ExternalPromocodeStore

export default class ExternalPromocodeStore extends ListStore<ExternalPromocodeModel> {
  fetchMethodName = 'externalPromocodes'
  ModelClass = ExternalPromocodeModel

  @action.bound async createExternalPromocode_api(data: CreateExternalPromocodeInput) {
    const { communication: { requester }, dropdownMessageHandler: { showDropdownMessage } } = this.rootStore

    this.loading = true
    try {
      const { createExternalPromocode } = await requester.createExternalPromocode({ data })

      this.mergeData([createExternalPromocode])
      showDropdownMessage({
        title: 'Promo code created successfully.',
        type: 'success',
      })
      return createExternalPromocode
    } catch (e) {
      return false
    } finally {
      this.loading = false
    }
  }

  @action.bound async validateExternalPromocode_api(data: ValidateExternalPromocodeInput) {
    const { requester } = this.rootStore.communication

    this.loading = true
    try {
      const { validateExternalPromocode } = await requester.validateExternalPromocode({ data })
      return validateExternalPromocode
    } finally {
      this.loading = false
    }
  }

  @action.bound updateExternalPromocode_api = async (data: UpdateExternalPromocodeInput) => {
    const { requester } = this.rootStore.communication
    this.loading = true
    try {
      const { updateExternalPromocode } = await requester.updateExternalPromocode({ data })
      this.mergeData([updateExternalPromocode])
      this.rootStore.dropdownMessageHandler.showDropdownMessage({
        title: 'Successfully updated promo code',
        type: 'success',
      })
    } catch (e) {
      this.rootStore.dropdownMessageHandler.showDropdownMessage({
        title: 'Failed to update promo code',
        type: 'error',
      })
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }
}